@import './pn-mainnav-common.scss';
@import '../../../globals/main.scss';

pn-mainnav-list {
  display: block;
  overflow: visible;
  list-style: none;
  margin: 0;
  padding: 0;
  grid-area: right;

  + pn-mainnav-list {
    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      grid-area: left;
      border-right: 0.1rem solid $gray200;
      margin-bottom: 1.6rem;
      margin-right: -0.7rem;
      padding-right: 0.7rem;
    }
  }

  [data-level='1'] > & {
    // height: 100%;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    @media screen and (min-width: $mobilenav-media-abovemobilemode) {
      height: 100%;
      display: flex;
      flex-flow: row;
      overflow: visible;
      padding: 0;
    }
  }

  &[data-navlist-showcolumns='true'] {
    [data-level='2'] > & {
      @media screen and (min-width: $mobilenav-media-abovemobilemode) {
        column-count: 2;
        column-gap: 1.6rem;
        padding-bottom: 1.6rem;
      }
    }
  }
}

.mainnav-list-heading {
  display: none;
  font-weight: bold;
  column-span: all;
  font-size: 1.8rem;
  padding: 1.4rem 1.4rem 1.4rem 4.8rem;
  @media screen and (min-width: $mobilenav-media-abovemobilemode) {
    display: block;
    padding: 0 1.4rem 1.4rem 1.4rem;
  }
}
